import { ChangeDetectionStrategy, Component, HostListener } from '@angular/core';
import screenfull from 'screenfull';

@Component({
  selector: 'header-fullscreen',
  template: `
    <i nz-icon class='mr-sm' [nzType]="status ? 'fullscreen-exit' : 'fullscreen'"></i>
    {{ status ? 'Exit Fullscreen' : 'Fullscreen' }}
  `,
  host: {
    '[class.flex-1]': 'true'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class HeaderFullScreenComponent {
  status = false;

  @HostListener('window:resize')
  _resize(): void {
    this.status = screenfull.isFullscreen;
  }

  @HostListener('click')
  _click(): void {
    if (screenfull.isEnabled) {
      screenfull.toggle();
    }
  }

  toggle(): void {
    if (screenfull.isEnabled) {
      screenfull.toggle();
    }
  }


}
